import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { NavigationExtras, Router } from '@angular/router';
import { UtilidadesService } from '../../@core/utils/utilidades.service';

@Component({
  selector: 'ngx-listado-actividades-home',
  templateUrl: './listado-actividades-home.component.html',
  styleUrls: ['./listado-actividades-home.component.scss']
})
export class ListadoActividadesHomeComponent implements OnInit {

  @Input() data;
  avisoAdmin:boolean = false;
  resultado:any;
  EsSocio:any ="";

  constructor(private _http: PeticionesHttpBackEndService,private router:Router,private utilidades: UtilidadesService) { 
    

  }

  ngOnInit() {
   if(this._http.comprobarLogin()){
    this._http.checkRoles().subscribe(
      result => {
        this.resultado = result;
       this.avisoAdmin = this.resultado.AvisoRol;
       this.EsSocio = this.resultado.EsSocio;
      },
      error => {
        
      }
    )
  }
  }

  edit(event): void {
    this._http.checkRoles().subscribe(
      result => {
        this.resultado = result;
       if(this.resultado.AvisoRol){
        let parametros: NavigationExtras = {
          queryParams: { 'ActividadId': event,'EsSocio':this.EsSocio }
        };
        this.router.navigate(['./actividad-detalle'], parametros);
       }else{
        this.utilidades.notificationWarning("Error",""+"No tiene privilegios para hacer esta acción"+"","top-left");
       }
      },
      error => {
        
      }
    )
  
}

visualizar(event): void {
  let parametros: NavigationExtras = {
    queryParams: { 'ActividadId': event,'EsSocio':this.resultado.EsSocio }
  };
  this.router.navigate(['./public/actividad'], parametros);

}



}
